import styled from 'styled-components';

import { ActionButton, breakpoints, Col } from '@notino/react-styleguide-v20';

import { FinalPriceRow } from '@sharedComponents/FinalPriceRow';

interface IStyledFooterRowProps {
  hasTwoButtons: boolean;
  mobileButtonOrder: boolean;
}

export const SFooterRow = styled.div<IStyledFooterRowProps>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${({ mobileButtonOrder }) => (mobileButtonOrder ? 'column-reverse' : 'column')};
  justify-content: ${({ hasTwoButtons }) => (hasTwoButtons ? 'space-between' : 'center')};

  > button:not(:first-child) {
    ${({ mobileButtonOrder }) => (mobileButtonOrder ? 'margin-bottom: 1rem;' : 'margin-top: 1rem;')};
  }

  @media (min-width: ${breakpoints.sm}) {
    flex-direction: row;

    > button:not(:first-child) {
      margin: 0;
    }
  }
`;

export const SActionButton = styled(ActionButton)<{ marginTop?: boolean }>`
  width: 100%;
  min-width: 12.5rem;
  margin-top: ${({ marginTop }) => (marginTop ? '1rem' : 'initial')};

  @media (min-width: ${breakpoints.sm}) {
    width: auto;
    margin-top: initial;
  }
`;

export const SActionButtonWrapper = styled(Col)`
  display: flex;
  align-items: end;
  flex-direction: column-reverse;
  justify-content: center;
  padding: 0;
  @media (min-width: ${breakpoints.sm}) {
    flex-direction: column;
  }
`;

export const SSmallText = styled.div`
  font-size: 0.75rem;
  max-width: 100%;
  margin: 0.25rem auto;
  text-align: center;
  @media (min-width: ${breakpoints.sm}) {
    max-width: 12.5rem;
  }
`;

export const SFinalPriceRow = styled(FinalPriceRow)`
  background-color: transparent;
  order: 1;
  margin: 0 -0.75rem 1rem 0;
  flex-grow: 1;
  font-size: 0.875rem;
  @media (min-width: ${breakpoints.sm}) {
    order: -1;
    width: 100%;
    justify-content: flex-end;
  }
  @media (min-width: ${breakpoints.lg}) {
    order: initial;
    align-items: center;
    padding: 0 1.5rem;
    margin: initial;
    text-align: right;
    width: initial;
  }
`;

export const SActionComponent = styled.div`
  width: 100%;
`;
